import React from "react";
import Tile from "../components/tile";
function Qualification() {
  return (
    <section className="section-qualification" id="education">
      <h4 className="heading-secondary heading-secondary--color u-margin-top-big">
        My Qualification
      </h4>
      <h4 className="heading-primary heading-primary--sub">Awesome Journey</h4>
      <div className="qual-detail">
        <div className="qual-detail__education-box">
          <div>
            <div className="icon-text-box">
              <img
                src="./icons/education.svg"
                className="icon-text-box__icon"
                alt="Certificate"
              />
              <h3 className="heading-tertiary heading-tertiary--sub">
                Education
              </h3>
            </div>
            <Tile school={'Jawaharlal Nehru University'} deg={'B.Tech + M.Tech in CSE'} cgpa={'CGPA: 7.2/ 9.0'} time={'2018 - 2023'}></Tile>
            <Tile school={'Satyadeo College'} deg={'Higher Secondary'} cgpa={'Percentage: 73.4%'} time={'2016 - 2018'}></Tile>
            <Tile school={'R.K.M.Vidya Mandir'} deg={'Secondary'} cgpa={'CGPA: 9.6/ 10.0'} time={'2015 - 2016'}></Tile>
          </div>
        </div>
        <div className="qual-detail__experience-box">
          <div className="icon-text-box">
            <img
              src="./icons/achive.svg"
              className="icon-text-box__icon"
              alt="Certificate 2"
            />
            <h3 className="heading-tertiary heading-tertiary--sub ">
              Experience
            </h3>
          </div>
            <Tile school={'SigSAIL Pvt. Ltd.'} deg={'Software Developer'} time={'Jun 2023 - continue'}></Tile>
            <Tile school={'Midas Lab'} deg={'Frontend Developer'} time={'Oct 2022 - Jun 2023'}></Tile>
            <Tile school={'Ringover France'} deg={'React Intern'} time={'Jun - Sep 2022'}></Tile>
            <Tile school={'IIT Bombay'} deg={'Flutter Intern'} time={'October 2021'}></Tile>
            <Tile school={'Kowi.Pvt.Ltd'} deg={'Flutter & VueJS Intern'} time={'Jul - Oct 2021'}></Tile>
        </div>
      </div>
    </section>
  );
}

export default Qualification;
